__turbopack_context__.v({
  "entra": "biblioteca-module__vlH7DG__entra",
});
